import React from "react";

const CookiePolicy = () => {
  return (
    <div className="legal-section">
      <h2>Cookie Policy</h2>
      <p>Last updated: March 19, 2024</p>

      <h3>1. Essential Cookies</h3>
      <p>
        SocratesLab uses only essential cookies that are strictly necessary for
        the platform to function properly. These cookies are required for:
      </p>
      <ul>
        <li>Authentication and maintaining your login session</li>
        <li>Basic platform functionality and security</li>
        <li>Microsoft Single Sign-On (SSO) service when enabled</li>
      </ul>

      <h3>2. How We Use Essential Cookies</h3>
      <p>Our essential cookies serve the following specific purposes:</p>
      <ul>
        <li>Keeping you securely logged into your account</li>
        <li>Remembering your authentication status</li>
        <li>
          Ensuring secure communication between your browser and our servers
        </li>
        <li>Maintaining necessary session information</li>
      </ul>

      <h3>3. Cookie Duration</h3>
      <p>
        Our essential cookies are either session-based (deleted when you close
        your browser) or persist for a limited time to maintain your login
        status. Authentication-related cookies typically expire after your
        session ends or within 365 days for "remember me" functionality.
      </p>

      <h3>4. Third-Party Authentication</h3>
      <p>
        When using Microsoft Single Sign-On (SSO), Microsoft's authentication
        service sets necessary cookies to maintain your login session. These
        cookies are essential for the SSO functionality and are governed by
        Microsoft's privacy and cookie policies.
      </p>

      <h3>5. Managing Cookies</h3>
      <p>
        While you can use your browser settings to manage cookies, please note
        that blocking or deleting essential cookies will prevent SocratesLab
        from functioning properly. Without these cookies, you won't be able to
        log in or use the platform's core features.
      </p>

      <h3>6. Updates to This Policy</h3>
      <p>
        We may update this Cookie Policy as our services evolve. Any changes
        will be reflected in the "Last updated" date at the top of this policy.
      </p>
    </div>
  );
};

export default CookiePolicy;
